import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import location from "../../../../assets/lodabranding/location.png";

import "../lodabranding.css";

function Brief() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleContextMenu = (e) => {
    e.preventDefault(); // Disable right-click
  };

  return (
    <Container
      fluid
      className="container-section"
      style={{
        backgroundColor: "#181818",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: isSmallScreen ? "auto" : "100vh",
        paddingBottom: isSmallScreen ? "5rem" : "auto",
        paddingTop: isSmallScreen ? "5rem" : "auto",
      }}
    >
      <Row style={{ height: "auto", width: "100%" }}>
        <Col xs={12} md={6} lg={6}>
          <br />
          <h2 style={{ fontWeight: "bold", fontSize: "3rem" }}>Lodapoint</h2>
          <p style={{ fontSize: "1rem", lineHeight: "1.5" }}>
            In today’s fast-paced world, convenience and reliability are key to
            moving people and goods efficiently. Lodapoint is your all-in-one
            solution, connecting users to a network of trusted transporters for
            truck hailing, ride-hailing, tricycle services, and deliveries.
          </p>
          <br />
          <p style={{ fontSize: "1rem", lineHeight: "1.5" }}>
            Whether you're booking a ride, transporting goods, or managing
            shipments, Lodapoint makes it seamless. With real-time tracking,
            transparent pricing, and a wide network of skilled drivers, we
            ensure that every journey, big or small, is handled with care. Join
            us and revolutionize the way you move and transport with ease.
          </p>
          <br />
          <button
            onClick={() =>
              window.open(
                "https://lodapoint.com/",
                "_blank",
                "noopener,noreferrer"
              )
            }
            style={{
              color: "#fff",
              backgroundColor: "#F36F2E",
              border: "none",
              padding: "0.5rem 1.5rem",
              borderRadius: "4px",
              cursor: "pointer",
              marginBottom: "2rem",
              textDecoration: "underline",
            }}
          >
            Visit Website
          </button>
        </Col>
        <br />
        <Col
          xs={12}
          md={6}
          lg={6}
          style={{ paddingTop: isSmallScreen ? "4rem" : "auto" }}
        >
          <Image
            src={location}
            alt="location"
            width="100%"
            draggable="false"
            onContextMenu={handleContextMenu}
            height="auto"
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Brief;
